import { EXERCISE_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getSecondaryMusclesExerciseUtil (exercise) {
  return getValueReduxUtil(exercise, EXERCISE_KEY.SECONDARY_MUSCLES) || []
}

export { getSecondaryMusclesExerciseUtil }
